export default {"src":"/_next/static/media/reviews.8aa3daae.svg","height":216,"width":328,"blurWidth":0,"blurHeight":0};